import type { Resolver } from 'cpool-schemas';
import type { z } from 'zod';

import { LoanRequestsTableDefinitionZod } from '../tables';

type Arguments = {
    loanRequestId: string;
};
export const schemaLoanRequestResolver_GetUserIds = LoanRequestsTableDefinitionZod.shape.userIds;

export type SchemaLoanRequestResolver_GetUserIds = z.infer<typeof schemaLoanRequestResolver_GetUserIds>;

export type LoanRequestResolver_GetUserIds = Resolver<Arguments, SchemaLoanRequestResolver_GetUserIds>;
